import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type CarSession = {
  entitlements?: Maybe<Array<CarSessionEntitlement>>;
  id: Scalars['String'];
  letOut?: Maybe<Scalars['Boolean']>;
  notification?: Maybe<Scalars['String']>;
  startFileKey?: Maybe<Scalars['String']>;
  startTime: Scalars['Int'];
  vrm: Scalars['String'];
};

export type CarSessionEntitlement = {
  amount?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  minutes: Scalars['Int'];
  validFrom: Scalars['Int'];
  validTo: Scalars['Int'];
};

export type CheckIfHasPassesInput = {
  phone: Scalars['String'];
};

export type CheckIfHasTokensInput = {
  phone: Scalars['String'];
  siteId: Scalars['Int'];
};

export enum DayClass {
  Weekday = 'WEEKDAY',
  Weekend = 'WEEKEND'
}

export type ExitLookupResult = {
  paidAt?: Maybe<Scalars['Int']>;
  paidMinutesAgo?: Maybe<Scalars['Int']>;
  session?: Maybe<CarSession>;
  status: ExitLookupStatus;
};

export enum ExitLookupStatus {
  LetOut = 'LET_OUT',
  NotFound = 'NOT_FOUND',
  NoPaymentRequired = 'NO_PAYMENT_REQUIRED',
  PaidOutsideWindow = 'PAID_OUTSIDE_WINDOW',
  PaidRecently = 'PAID_RECENTLY',
  Unpaid = 'UNPAID'
}

export enum FeeType {
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  SpecialTariff = 'SPECIAL_TARIFF',
  Weekly = 'WEEKLY'
}

export type MfaTokenInput = {
  phone: Scalars['String'];
  siteId: Scalars['Int'];
  token: Scalars['String'];
};

export type MonthlyPassMfaInput = {
  phone: Scalars['String'];
  token: Scalars['String'];
};

export type MonthlyPassPermit = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  parkingTicketId: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  siteId: Scalars['Float'];
  untilTime: Scalars['Float'];
  vrm: Scalars['String'];
};

export type Mutation = {
  checkIfHasToken: Payment;
  findExitSession: ExitLookupResult;
  findSessionBySiteAndVrm?: Maybe<CarSession>;
  getPaymentLink: Payment;
  payWithToken: Payment;
  removePlate: Scalars['Boolean'];
  removeToken: Scalars['Boolean'];
  renewMonthlyPass: RenewalMonthly;
  renewWeeklyPass: RenewalMonthly;
  updateVrm: MonthlyPassPermit;
  updateWeeklyVrm: WeeklyPassPermit;
  validateMfa: ValidationResponse;
  validateMonthlyPassMfa: PassMfaResponse;
  validateMonthlyUserPhone: SmsValidation;
};


export type MutationCheckIfHasTokenArgs = {
  hasTokensArgs: CheckIfHasTokensInput;
};


export type MutationFindExitSessionArgs = {
  sessionId?: InputMaybe<Scalars['String']>;
  siteId: Scalars['Int'];
  vrm: Scalars['String'];
  windowMinutes?: InputMaybe<Scalars['Int']>;
};


export type MutationFindSessionBySiteAndVrmArgs = {
  siteId: Scalars['Int'];
  vrm: Scalars['String'];
};


export type MutationGetPaymentLinkArgs = {
  paymentArgs: PaymentInput;
};


export type MutationPayWithTokenArgs = {
  paymentArgs: TokenPaymentInput;
};


export type MutationRemovePlateArgs = {
  plateId: Scalars['Int'];
};


export type MutationRemoveTokenArgs = {
  siteId: Scalars['String'];
  token: Scalars['String'];
};


export type MutationRenewMonthlyPassArgs = {
  renewArgs: RenewMonthlyPassInput;
};


export type MutationRenewWeeklyPassArgs = {
  renewArgs: RenewWeeklyPassInput;
};


export type MutationUpdateVrmArgs = {
  updateVrmArgs: UpdateVrmInput;
};


export type MutationUpdateWeeklyVrmArgs = {
  updateVrmArgs: UpdateWeeklyVrmInput;
};


export type MutationValidateMfaArgs = {
  mfaTokenArgs: MfaTokenInput;
};


export type MutationValidateMonthlyPassMfaArgs = {
  mfaTokenArgs: MonthlyPassMfaInput;
};


export type MutationValidateMonthlyUserPhoneArgs = {
  hasTokensArgs: CheckIfHasPassesInput;
};

export type PassMfaResponse = {
  monthlyPasses: Array<MonthlyPassPermit>;
  weeklyPasses: Array<WeeklyPassPermit>;
};

export type Payment = {
  error?: Maybe<Scalars['String']>;
  hasTokens: Scalars['Boolean'];
  redirectUrl?: Maybe<Scalars['String']>;
};

export type PaymentInput = {
  carSessionId?: InputMaybe<Scalars['String']>;
  /** Number of minutes that the permit is valid for */
  duration: Scalars['Int'];
  /** Email for contact information */
  email?: InputMaybe<Scalars['String']>;
  /** Describes what type of Fee is the user selecting */
  feeType: FeeType;
  /** User name */
  name: Scalars['String'];
  /** Timeline idempotency session ID from getSites; anchors ticket timing to when the timeline was loaded */
  parkingTicketSessionId?: InputMaybe<Scalars['String']>;
  /** Phone for contact information */
  phone?: InputMaybe<Scalars['String']>;
  /** QR Code Identifier for site */
  qrCode: Scalars['String'];
  /** Flag to determine if reached max duration */
  reachedMaxDuration: Scalars['Boolean'];
  /** Flag to receive email notifications */
  receiveEmails: Scalars['Boolean'];
  /** Flag to receive sms notifications */
  receiveSms: Scalars['Boolean'];
  specialTariffPricingId?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  /** Flag to save payment information */
  storePayment: Scalars['Boolean'];
  /** Accumulated cost from the selected timeline step */
  timelineStepAccumulatedCost?: InputMaybe<Scalars['Float']>;
  /** Duration in minutes from the selected timeline step */
  timelineStepDurationMinutes?: InputMaybe<Scalars['Int']>;
  /** Special tariff ID from the selected timeline step (if applicable) */
  timelineStepSpecialTariffId?: InputMaybe<Scalars['Int']>;
  /** Topup fixed time */
  topupFixedTime?: InputMaybe<Scalars['Int']>;
  /** Vehicle registration number */
  vrm: Scalars['String'];
};

export type PaymentToken = {
  cardExpiry: Scalars['String'];
  cardHolder: Scalars['String'];
  cardNumber: Scalars['String'];
  cardToken: Scalars['String'];
  cardType: Scalars['String'];
  id: Scalars['String'];
};

export type PricingTier = {
  costPerHour: Scalars['Float'];
  dayClass: DayClass;
  endHours?: Maybe<Scalars['Float']>;
  id: Scalars['Float'];
  order: Scalars['Int'];
  siteId: Scalars['Float'];
  startHours: Scalars['Float'];
};

export type Query = {
  activeSiteNotifications: Array<SiteNotification>;
  getSite?: Maybe<Site>;
  getSites: Array<Site>;
  getTopupTimeline: Array<SiteTimelineStep>;
  validateRenewal: Renewal;
};


export type QueryGetSiteArgs = {
  siteId: Scalars['Int'];
};


export type QueryGetTopupTimelineArgs = {
  siteId: Scalars['Int'];
  vrm: Scalars['String'];
};


export type QueryValidateRenewalArgs = {
  sessionCode: Scalars['String'];
};

export type RenewMonthlyPassInput = {
  monthlyPassPermitId: Scalars['String'];
};

export type RenewWeeklyPassInput = {
  weeklyPassPermitId: Scalars['String'];
};

export type Renewal = {
  error?: Maybe<Scalars['String']>;
  renewalInfo?: Maybe<RenewalInfo>;
  successful: Scalars['Boolean'];
};

export type RenewalInfo = {
  /** Number of minutes that the permit is valid for */
  duration: Scalars['Int'];
  /** User email */
  email: Scalars['String'];
  /** Describes what type of Fee is the user selecting */
  feeType: FeeType;
  /** User phone */
  phone: Scalars['String'];
  /** Site Id */
  siteId: Scalars['Int'];
  /** Site Name */
  siteName: Scalars['String'];
  tokens: Array<PaymentToken>;
  /** Vehicle registration number */
  vrm: Scalars['String'];
};

export type RenewalMonthly = {
  id: Scalars['String'];
  parkingTicketId: Scalars['String'];
  untilTime: Scalars['Float'];
};

export enum SessionTimeUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  Months = 'MONTHS'
}

export type Site = {
  availableMonthlyPasses: Scalars['Float'];
  availableWeeklyPasses: Scalars['Float'];
  closedMessage?: Maybe<Scalars['String']>;
  costPerHour: Scalars['Float'];
  costPerHourWeekend: Scalars['Float'];
  freeTime: Scalars['Float'];
  hasFreeTime: Scalars['Boolean'];
  hasMaxTime: Scalars['Boolean'];
  hasMaxTimeWeekend: Scalars['Boolean'];
  hasMonthly: Scalars['Boolean'];
  hasWeekly: Scalars['Boolean'];
  id: Scalars['Float'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  maxCost: Scalars['Float'];
  maxCostWeekend: Scalars['Float'];
  maxTime: Scalars['Float'];
  maxTimeWeekend: Scalars['Float'];
  minimumTime: Scalars['Float'];
  monthlyFee: Scalars['Float'];
  name: Scalars['String'];
  parkingTicketSessionId?: Maybe<Scalars['String']>;
  paymarkSecret?: Maybe<Scalars['String']>;
  paymentType: Scalars['String'];
  pricingTiers?: Maybe<Array<PricingTier>>;
  qrCode: Scalars['String'];
  siteConfiguration?: Maybe<SiteConfiguration>;
  siteStatus: SiteStatus;
  siteType: SiteType;
  specialTariffDomain: Scalars['String'];
  specialTariffPricing?: Maybe<Array<SpecialTariffPricing>>;
  timeStep: Scalars['Float'];
  timeline?: Maybe<Array<SiteTimelineStep>>;
  transactionFee: Scalars['Float'];
  weeklyFee: Scalars['Float'];
  zatParkId: Scalars['Float'];
};

export type SiteConfiguration = {
  logoUrl?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
};

export type SiteNotification = {
  expiration: Scalars['Int'];
  id: Scalars['Int'];
  message: Scalars['String'];
  siteId?: Maybe<Scalars['Int']>;
};

export enum SiteStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type SiteTimelineStep = {
  accumulatedCost: Scalars['Float'];
  durationMinutes: Scalars['Int'];
  fixedTime?: Maybe<Scalars['String']>;
  specialTariffId?: Maybe<Scalars['Int']>;
  specialTariffIncludedMinutes?: Maybe<Scalars['Int']>;
  specialTariffName?: Maybe<Scalars['String']>;
  specialTariffPrice?: Maybe<Scalars['Float']>;
};

export enum SiteType {
  CentralPark = 'CENTRAL_PARK',
  Mainland = 'MAINLAND'
}

export type SmsValidation = {
  error?: Maybe<Scalars['String']>;
  hasPasses: Scalars['Boolean'];
};

export type SpecialTariffPricing = {
  dayClass: DayClass;
  end: Scalars['String'];
  id: Scalars['Float'];
  message: Scalars['String'];
  name: Scalars['String'];
  price: Scalars['Float'];
  sessionTime?: Maybe<Scalars['Int']>;
  sessionTimeUnit?: Maybe<SessionTimeUnit>;
  start: Scalars['String'];
  tariffType: TariffType;
  untilTime?: Maybe<Scalars['String']>;
};

export enum TariffType {
  Regular = 'REGULAR',
  Restricted = 'RESTRICTED'
}

export type TokenPaymentInput = {
  carSessionId?: InputMaybe<Scalars['String']>;
  /** Number of minutes that the permit is valid for */
  duration: Scalars['Int'];
  /** Email for contact information */
  email?: InputMaybe<Scalars['String']>;
  /** Describes what type of Fee is the user selecting */
  feeType: FeeType;
  /** User name */
  name: Scalars['String'];
  /** Timeline idempotency session ID from getSites; anchors ticket timing to when the timeline was loaded */
  parkingTicketSessionId?: InputMaybe<Scalars['String']>;
  /** Phone for contact information */
  phone?: InputMaybe<Scalars['String']>;
  /** QR Code Identifier for site */
  qrCode: Scalars['String'];
  /** Flag to determine if reached max duration */
  reachedMaxDuration: Scalars['Boolean'];
  /** Flag to receive email notifications */
  receiveEmails: Scalars['Boolean'];
  /** Flag to receive sms notifications */
  receiveSms: Scalars['Boolean'];
  specialTariffPricingId?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  /** Flag to save payment information */
  storePayment: Scalars['Boolean'];
  /** Accumulated cost from the selected timeline step */
  timelineStepAccumulatedCost?: InputMaybe<Scalars['Float']>;
  /** Duration in minutes from the selected timeline step */
  timelineStepDurationMinutes?: InputMaybe<Scalars['Int']>;
  /** Special tariff ID from the selected timeline step (if applicable) */
  timelineStepSpecialTariffId?: InputMaybe<Scalars['Int']>;
  /** Token Identifier */
  token: Scalars['String'];
  /** Topup fixed time */
  topupFixedTime?: InputMaybe<Scalars['Int']>;
  /** Vehicle registration number */
  vrm: Scalars['String'];
};

export type UpdateVrmInput = {
  monthlyPassPermitId: Scalars['String'];
  newVrm: Scalars['String'];
};

export type UpdateWeeklyVrmInput = {
  newVrm: Scalars['String'];
  weeklyPassPermitId: Scalars['String'];
};

export type UserPlate = {
  id: Scalars['Int'];
  vrm: Scalars['String'];
};

export type ValidationResponse = {
  error?: Maybe<Scalars['String']>;
  plates: Array<UserPlate>;
  successful: Scalars['Boolean'];
  tokens: Array<PaymentToken>;
};

export type WeeklyPassPermit = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  parkingTicketId: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  siteId: Scalars['Float'];
  untilTime: Scalars['Float'];
  vrm: Scalars['String'];
};

export type CheckIfHasTokenMutationVariables = Exact<{
  phone: Scalars['String'];
  siteId: Scalars['Int'];
}>;


export type CheckIfHasTokenMutation = { checkIfHasToken: { error?: string | null, hasTokens: boolean } };

export type FindSessionBySiteAndVrmMutationVariables = Exact<{
  siteId: Scalars['Int'];
  vrm: Scalars['String'];
}>;


export type FindSessionBySiteAndVrmMutation = { findSessionBySiteAndVrm?: { id: string, vrm: string, startTime: number, startFileKey?: string | null, letOut?: boolean | null, notification?: string | null, entitlements?: Array<{ id: number, minutes: number, validFrom: number, validTo: number, amount?: number | null }> | null } | null };

export type GetPaymentLinkMutationVariables = Exact<{
  qrCode: Scalars['String'];
  duration: Scalars['Int'];
  vrm: Scalars['String'];
  name: Scalars['String'];
  storePayment: Scalars['Boolean'];
  receiveEmails: Scalars['Boolean'];
  receiveSms: Scalars['Boolean'];
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  feeType: FeeType;
  reachedMaxDuration: Scalars['Boolean'];
  specialTariffPricingId?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  timelineStepDurationMinutes?: InputMaybe<Scalars['Int']>;
  timelineStepAccumulatedCost?: InputMaybe<Scalars['Float']>;
  timelineStepSpecialTariffId?: InputMaybe<Scalars['Int']>;
  topupFixedTime?: InputMaybe<Scalars['Int']>;
  parkingTicketSessionId?: InputMaybe<Scalars['String']>;
}>;


export type GetPaymentLinkMutation = { getPaymentLink: { redirectUrl?: string | null, error?: string | null } };

export type GetSitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSitesQuery = { activeSiteNotifications: Array<{ id: number, message: string, expiration: number, siteId?: number | null }>, getSites: Array<{ id: number, name: string, zatParkId: number, costPerHour: number, costPerHourWeekend: number, qrCode: string, minimumTime: number, timeStep: number, hasMonthly: boolean, monthlyFee: number, availableMonthlyPasses: number, hasWeekly: boolean, weeklyFee: number, availableWeeklyPasses: number, transactionFee: number, specialTariffDomain: string, hasMaxTime: boolean, hasMaxTimeWeekend: boolean, maxTime: number, maxTimeWeekend: number, maxCost: number, maxCostWeekend: number, hasFreeTime: boolean, freeTime: number, siteType: SiteType, siteStatus: SiteStatus, closedMessage?: string | null, paymentType: string, parkingTicketSessionId?: string | null, latitude?: number | null, longitude?: number | null, specialTariffPricing?: Array<{ id: number, price: number, start: string, end: string, name: string, message: string, dayClass: DayClass, untilTime?: string | null, sessionTime?: number | null, sessionTimeUnit?: SessionTimeUnit | null, tariffType: TariffType }> | null, pricingTiers?: Array<{ id: number, costPerHour: number, dayClass: DayClass, startHours: number, endHours?: number | null, order: number, siteId: number }> | null, siteConfiguration?: { primaryColor?: string | null, secondaryColor?: string | null, logoUrl?: string | null } | null, timeline?: Array<{ durationMinutes: number, accumulatedCost: number, specialTariffId?: number | null, specialTariffName?: string | null, specialTariffPrice?: number | null, specialTariffIncludedMinutes?: number | null, fixedTime?: string | null }> | null }> };

export type GetTopupTimelineQueryVariables = Exact<{
  vrm: Scalars['String'];
  siteId: Scalars['Int'];
}>;


export type GetTopupTimelineQuery = { getTopupTimeline: Array<{ durationMinutes: number, accumulatedCost: number, specialTariffId?: number | null, specialTariffName?: string | null, specialTariffPrice?: number | null, specialTariffIncludedMinutes?: number | null, fixedTime?: string | null }> };

export type PayWithTokenMutationVariables = Exact<{
  qrCode: Scalars['String'];
  duration: Scalars['Int'];
  vrm: Scalars['String'];
  name: Scalars['String'];
  storePayment: Scalars['Boolean'];
  receiveEmails: Scalars['Boolean'];
  receiveSms: Scalars['Boolean'];
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  feeType: FeeType;
  reachedMaxDuration: Scalars['Boolean'];
  specialTariffPricingId?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['Int']>;
  timelineStepDurationMinutes?: InputMaybe<Scalars['Int']>;
  timelineStepAccumulatedCost?: InputMaybe<Scalars['Float']>;
  timelineStepSpecialTariffId?: InputMaybe<Scalars['Int']>;
  topupFixedTime?: InputMaybe<Scalars['Int']>;
  parkingTicketSessionId?: InputMaybe<Scalars['String']>;
}>;


export type PayWithTokenMutation = { payWithToken: { redirectUrl?: string | null, error?: string | null } };

export type RemovePlateMutationVariables = Exact<{
  plateId: Scalars['Int'];
}>;


export type RemovePlateMutation = { removePlate: boolean };

export type RemoveTokenMutationVariables = Exact<{
  token: Scalars['String'];
  siteId: Scalars['String'];
}>;


export type RemoveTokenMutation = { removeToken: boolean };

export type RenewMonthlyPassMutationVariables = Exact<{
  monthlyPassPermitId: Scalars['String'];
}>;


export type RenewMonthlyPassMutation = { renewMonthlyPass: { id: string, untilTime: number } };

export type RenewWeeklyPassMutationVariables = Exact<{
  weeklyPassPermitId: Scalars['String'];
}>;


export type RenewWeeklyPassMutation = { renewWeeklyPass: { id: string, untilTime: number } };

export type UpdateVrmMutationVariables = Exact<{
  monthlyPassPermitId: Scalars['String'];
  newVrm: Scalars['String'];
}>;


export type UpdateVrmMutation = { updateVrm: { id: string, vrm: string, untilTime: number } };

export type UpdateWeeklyVrmMutationVariables = Exact<{
  weeklyPassPermitId: Scalars['String'];
  newVrm: Scalars['String'];
}>;


export type UpdateWeeklyVrmMutation = { updateWeeklyVrm: { id: string, vrm: string, untilTime: number } };

export type ValidateMfaMutationVariables = Exact<{
  token: Scalars['String'];
  phone: Scalars['String'];
  siteId: Scalars['Int'];
}>;


export type ValidateMfaMutation = { validateMfa: { successful: boolean, error?: string | null, tokens: Array<{ id: string, cardToken: string, cardNumber: string, cardType: string, cardExpiry: string, cardHolder: string }>, plates: Array<{ id: number, vrm: string }> } };

export type ValidateMonthlyPassMfaMutationVariables = Exact<{
  phone: Scalars['String'];
  token: Scalars['String'];
}>;


export type ValidateMonthlyPassMfaMutation = { validateMonthlyPassMfa: { monthlyPasses: Array<{ id: string, vrm: string, untilTime: number, parkingTicketId: string, site?: { id: number, name: string } | null }>, weeklyPasses: Array<{ id: string, vrm: string, untilTime: number, parkingTicketId: string, site?: { id: number, name: string } | null }> } };

export type ValidateMonthlyUserPhoneMutationVariables = Exact<{
  phone: Scalars['String'];
}>;


export type ValidateMonthlyUserPhoneMutation = { validateMonthlyUserPhone: { error?: string | null, hasPasses: boolean } };

export type ValidateRenewalQueryVariables = Exact<{
  sessionCode: Scalars['String'];
}>;


export type ValidateRenewalQuery = { validateRenewal: { successful: boolean, error?: string | null, renewalInfo?: { vrm: string, siteId: number, siteName: string, duration: number, email: string, phone: string, feeType: FeeType, tokens: Array<{ id: string, cardToken: string, cardNumber: string, cardType: string, cardExpiry: string, cardHolder: string }> } | null } };


export const CheckIfHasTokenDocument = gql`
    mutation CheckIfHasToken($phone: String!, $siteId: Int!) {
  checkIfHasToken(hasTokensArgs: {phone: $phone, siteId: $siteId}) {
    error
    hasTokens
  }
}
    `;
export type CheckIfHasTokenMutationFn = Apollo.MutationFunction<CheckIfHasTokenMutation, CheckIfHasTokenMutationVariables>;

/**
 * __useCheckIfHasTokenMutation__
 *
 * To run a mutation, you first call `useCheckIfHasTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckIfHasTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkIfHasTokenMutation, { data, loading, error }] = useCheckIfHasTokenMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useCheckIfHasTokenMutation(baseOptions?: Apollo.MutationHookOptions<CheckIfHasTokenMutation, CheckIfHasTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckIfHasTokenMutation, CheckIfHasTokenMutationVariables>(CheckIfHasTokenDocument, options);
      }
export type CheckIfHasTokenMutationHookResult = ReturnType<typeof useCheckIfHasTokenMutation>;
export type CheckIfHasTokenMutationResult = Apollo.MutationResult<CheckIfHasTokenMutation>;
export type CheckIfHasTokenMutationOptions = Apollo.BaseMutationOptions<CheckIfHasTokenMutation, CheckIfHasTokenMutationVariables>;
export const FindSessionBySiteAndVrmDocument = gql`
    mutation findSessionBySiteAndVrm($siteId: Int!, $vrm: String!) {
  findSessionBySiteAndVrm(siteId: $siteId, vrm: $vrm) {
    id
    vrm
    startTime
    startFileKey
    letOut
    notification
    entitlements {
      id
      minutes
      validFrom
      validTo
      amount
    }
  }
}
    `;
export type FindSessionBySiteAndVrmMutationFn = Apollo.MutationFunction<FindSessionBySiteAndVrmMutation, FindSessionBySiteAndVrmMutationVariables>;

/**
 * __useFindSessionBySiteAndVrmMutation__
 *
 * To run a mutation, you first call `useFindSessionBySiteAndVrmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFindSessionBySiteAndVrmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [findSessionBySiteAndVrmMutation, { data, loading, error }] = useFindSessionBySiteAndVrmMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      vrm: // value for 'vrm'
 *   },
 * });
 */
export function useFindSessionBySiteAndVrmMutation(baseOptions?: Apollo.MutationHookOptions<FindSessionBySiteAndVrmMutation, FindSessionBySiteAndVrmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FindSessionBySiteAndVrmMutation, FindSessionBySiteAndVrmMutationVariables>(FindSessionBySiteAndVrmDocument, options);
      }
export type FindSessionBySiteAndVrmMutationHookResult = ReturnType<typeof useFindSessionBySiteAndVrmMutation>;
export type FindSessionBySiteAndVrmMutationResult = Apollo.MutationResult<FindSessionBySiteAndVrmMutation>;
export type FindSessionBySiteAndVrmMutationOptions = Apollo.BaseMutationOptions<FindSessionBySiteAndVrmMutation, FindSessionBySiteAndVrmMutationVariables>;
export const GetPaymentLinkDocument = gql`
    mutation GetPaymentLink($qrCode: String!, $duration: Int!, $vrm: String!, $name: String!, $storePayment: Boolean!, $receiveEmails: Boolean!, $receiveSms: Boolean!, $email: String, $phone: String, $feeType: FeeType!, $reachedMaxDuration: Boolean!, $specialTariffPricingId: Int, $startTime: Int, $timelineStepDurationMinutes: Int, $timelineStepAccumulatedCost: Float, $timelineStepSpecialTariffId: Int, $topupFixedTime: Int, $parkingTicketSessionId: String) {
  getPaymentLink(
    paymentArgs: {qrCode: $qrCode, duration: $duration, vrm: $vrm, name: $name, storePayment: $storePayment, receiveEmails: $receiveEmails, receiveSms: $receiveSms, email: $email, phone: $phone, feeType: $feeType, reachedMaxDuration: $reachedMaxDuration, specialTariffPricingId: $specialTariffPricingId, startTime: $startTime, timelineStepDurationMinutes: $timelineStepDurationMinutes, timelineStepAccumulatedCost: $timelineStepAccumulatedCost, timelineStepSpecialTariffId: $timelineStepSpecialTariffId, topupFixedTime: $topupFixedTime, parkingTicketSessionId: $parkingTicketSessionId}
  ) {
    redirectUrl
    error
  }
}
    `;
export type GetPaymentLinkMutationFn = Apollo.MutationFunction<GetPaymentLinkMutation, GetPaymentLinkMutationVariables>;

/**
 * __useGetPaymentLinkMutation__
 *
 * To run a mutation, you first call `useGetPaymentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPaymentLinkMutation, { data, loading, error }] = useGetPaymentLinkMutation({
 *   variables: {
 *      qrCode: // value for 'qrCode'
 *      duration: // value for 'duration'
 *      vrm: // value for 'vrm'
 *      name: // value for 'name'
 *      storePayment: // value for 'storePayment'
 *      receiveEmails: // value for 'receiveEmails'
 *      receiveSms: // value for 'receiveSms'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      feeType: // value for 'feeType'
 *      reachedMaxDuration: // value for 'reachedMaxDuration'
 *      specialTariffPricingId: // value for 'specialTariffPricingId'
 *      startTime: // value for 'startTime'
 *      timelineStepDurationMinutes: // value for 'timelineStepDurationMinutes'
 *      timelineStepAccumulatedCost: // value for 'timelineStepAccumulatedCost'
 *      timelineStepSpecialTariffId: // value for 'timelineStepSpecialTariffId'
 *      topupFixedTime: // value for 'topupFixedTime'
 *      parkingTicketSessionId: // value for 'parkingTicketSessionId'
 *   },
 * });
 */
export function useGetPaymentLinkMutation(baseOptions?: Apollo.MutationHookOptions<GetPaymentLinkMutation, GetPaymentLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetPaymentLinkMutation, GetPaymentLinkMutationVariables>(GetPaymentLinkDocument, options);
      }
export type GetPaymentLinkMutationHookResult = ReturnType<typeof useGetPaymentLinkMutation>;
export type GetPaymentLinkMutationResult = Apollo.MutationResult<GetPaymentLinkMutation>;
export type GetPaymentLinkMutationOptions = Apollo.BaseMutationOptions<GetPaymentLinkMutation, GetPaymentLinkMutationVariables>;
export const GetSitesDocument = gql`
    query GetSites {
  activeSiteNotifications {
    id
    message
    expiration
    siteId
  }
  getSites {
    id
    name
    zatParkId
    costPerHour
    costPerHourWeekend
    qrCode
    minimumTime
    timeStep
    hasMonthly
    monthlyFee
    availableMonthlyPasses
    hasWeekly
    weeklyFee
    availableWeeklyPasses
    transactionFee
    specialTariffDomain
    specialTariffPricing {
      id
      price
      start
      end
      name
      message
      dayClass
      untilTime
      sessionTime
      sessionTimeUnit
      tariffType
    }
    hasMaxTime
    hasMaxTimeWeekend
    maxTime
    maxTimeWeekend
    maxCost
    maxCostWeekend
    hasFreeTime
    freeTime
    siteType
    siteStatus
    closedMessage
    paymentType
    parkingTicketSessionId
    latitude
    longitude
    pricingTiers {
      id
      costPerHour
      dayClass
      startHours
      endHours
      order
      siteId
    }
    siteConfiguration {
      primaryColor
      secondaryColor
      logoUrl
    }
    timeline {
      durationMinutes
      accumulatedCost
      specialTariffId
      specialTariffName
      specialTariffPrice
      specialTariffIncludedMinutes
      fixedTime
    }
  }
}
    `;

/**
 * __useGetSitesQuery__
 *
 * To run a query within a React component, call `useGetSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSitesQuery(baseOptions?: Apollo.QueryHookOptions<GetSitesQuery, GetSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument, options);
      }
export function useGetSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSitesQuery, GetSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument, options);
        }
export type GetSitesQueryHookResult = ReturnType<typeof useGetSitesQuery>;
export type GetSitesLazyQueryHookResult = ReturnType<typeof useGetSitesLazyQuery>;
export type GetSitesQueryResult = Apollo.QueryResult<GetSitesQuery, GetSitesQueryVariables>;
export function refetchGetSitesQuery(variables?: GetSitesQueryVariables) {
      return { query: GetSitesDocument, variables: variables }
    }
export const GetTopupTimelineDocument = gql`
    query GetTopupTimeline($vrm: String!, $siteId: Int!) {
  getTopupTimeline(vrm: $vrm, siteId: $siteId) {
    durationMinutes
    accumulatedCost
    specialTariffId
    specialTariffName
    specialTariffPrice
    specialTariffIncludedMinutes
    fixedTime
  }
}
    `;

/**
 * __useGetTopupTimelineQuery__
 *
 * To run a query within a React component, call `useGetTopupTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopupTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopupTimelineQuery({
 *   variables: {
 *      vrm: // value for 'vrm'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetTopupTimelineQuery(baseOptions: Apollo.QueryHookOptions<GetTopupTimelineQuery, GetTopupTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopupTimelineQuery, GetTopupTimelineQueryVariables>(GetTopupTimelineDocument, options);
      }
export function useGetTopupTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopupTimelineQuery, GetTopupTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopupTimelineQuery, GetTopupTimelineQueryVariables>(GetTopupTimelineDocument, options);
        }
export type GetTopupTimelineQueryHookResult = ReturnType<typeof useGetTopupTimelineQuery>;
export type GetTopupTimelineLazyQueryHookResult = ReturnType<typeof useGetTopupTimelineLazyQuery>;
export type GetTopupTimelineQueryResult = Apollo.QueryResult<GetTopupTimelineQuery, GetTopupTimelineQueryVariables>;
export function refetchGetTopupTimelineQuery(variables: GetTopupTimelineQueryVariables) {
      return { query: GetTopupTimelineDocument, variables: variables }
    }
export const PayWithTokenDocument = gql`
    mutation PayWithToken($qrCode: String!, $duration: Int!, $vrm: String!, $name: String!, $storePayment: Boolean!, $receiveEmails: Boolean!, $receiveSms: Boolean!, $email: String, $phone: String, $token: String!, $feeType: FeeType!, $reachedMaxDuration: Boolean!, $specialTariffPricingId: Int, $startTime: Int, $timelineStepDurationMinutes: Int, $timelineStepAccumulatedCost: Float, $timelineStepSpecialTariffId: Int, $topupFixedTime: Int, $parkingTicketSessionId: String) {
  payWithToken(
    paymentArgs: {qrCode: $qrCode, duration: $duration, vrm: $vrm, name: $name, storePayment: $storePayment, receiveEmails: $receiveEmails, receiveSms: $receiveSms, email: $email, phone: $phone, token: $token, feeType: $feeType, reachedMaxDuration: $reachedMaxDuration, specialTariffPricingId: $specialTariffPricingId, startTime: $startTime, timelineStepDurationMinutes: $timelineStepDurationMinutes, timelineStepAccumulatedCost: $timelineStepAccumulatedCost, timelineStepSpecialTariffId: $timelineStepSpecialTariffId, topupFixedTime: $topupFixedTime, parkingTicketSessionId: $parkingTicketSessionId}
  ) {
    redirectUrl
    error
  }
}
    `;
export type PayWithTokenMutationFn = Apollo.MutationFunction<PayWithTokenMutation, PayWithTokenMutationVariables>;

/**
 * __usePayWithTokenMutation__
 *
 * To run a mutation, you first call `usePayWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payWithTokenMutation, { data, loading, error }] = usePayWithTokenMutation({
 *   variables: {
 *      qrCode: // value for 'qrCode'
 *      duration: // value for 'duration'
 *      vrm: // value for 'vrm'
 *      name: // value for 'name'
 *      storePayment: // value for 'storePayment'
 *      receiveEmails: // value for 'receiveEmails'
 *      receiveSms: // value for 'receiveSms'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      token: // value for 'token'
 *      feeType: // value for 'feeType'
 *      reachedMaxDuration: // value for 'reachedMaxDuration'
 *      specialTariffPricingId: // value for 'specialTariffPricingId'
 *      startTime: // value for 'startTime'
 *      timelineStepDurationMinutes: // value for 'timelineStepDurationMinutes'
 *      timelineStepAccumulatedCost: // value for 'timelineStepAccumulatedCost'
 *      timelineStepSpecialTariffId: // value for 'timelineStepSpecialTariffId'
 *      topupFixedTime: // value for 'topupFixedTime'
 *      parkingTicketSessionId: // value for 'parkingTicketSessionId'
 *   },
 * });
 */
export function usePayWithTokenMutation(baseOptions?: Apollo.MutationHookOptions<PayWithTokenMutation, PayWithTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayWithTokenMutation, PayWithTokenMutationVariables>(PayWithTokenDocument, options);
      }
export type PayWithTokenMutationHookResult = ReturnType<typeof usePayWithTokenMutation>;
export type PayWithTokenMutationResult = Apollo.MutationResult<PayWithTokenMutation>;
export type PayWithTokenMutationOptions = Apollo.BaseMutationOptions<PayWithTokenMutation, PayWithTokenMutationVariables>;
export const RemovePlateDocument = gql`
    mutation RemovePlate($plateId: Int!) {
  removePlate(plateId: $plateId)
}
    `;
export type RemovePlateMutationFn = Apollo.MutationFunction<RemovePlateMutation, RemovePlateMutationVariables>;

/**
 * __useRemovePlateMutation__
 *
 * To run a mutation, you first call `useRemovePlateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlateMutation, { data, loading, error }] = useRemovePlateMutation({
 *   variables: {
 *      plateId: // value for 'plateId'
 *   },
 * });
 */
export function useRemovePlateMutation(baseOptions?: Apollo.MutationHookOptions<RemovePlateMutation, RemovePlateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePlateMutation, RemovePlateMutationVariables>(RemovePlateDocument, options);
      }
export type RemovePlateMutationHookResult = ReturnType<typeof useRemovePlateMutation>;
export type RemovePlateMutationResult = Apollo.MutationResult<RemovePlateMutation>;
export type RemovePlateMutationOptions = Apollo.BaseMutationOptions<RemovePlateMutation, RemovePlateMutationVariables>;
export const RemoveTokenDocument = gql`
    mutation RemoveToken($token: String!, $siteId: String!) {
  removeToken(token: $token, siteId: $siteId)
}
    `;
export type RemoveTokenMutationFn = Apollo.MutationFunction<RemoveTokenMutation, RemoveTokenMutationVariables>;

/**
 * __useRemoveTokenMutation__
 *
 * To run a mutation, you first call `useRemoveTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTokenMutation, { data, loading, error }] = useRemoveTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useRemoveTokenMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTokenMutation, RemoveTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTokenMutation, RemoveTokenMutationVariables>(RemoveTokenDocument, options);
      }
export type RemoveTokenMutationHookResult = ReturnType<typeof useRemoveTokenMutation>;
export type RemoveTokenMutationResult = Apollo.MutationResult<RemoveTokenMutation>;
export type RemoveTokenMutationOptions = Apollo.BaseMutationOptions<RemoveTokenMutation, RemoveTokenMutationVariables>;
export const RenewMonthlyPassDocument = gql`
    mutation RenewMonthlyPass($monthlyPassPermitId: String!) {
  renewMonthlyPass(renewArgs: {monthlyPassPermitId: $monthlyPassPermitId}) {
    id
    untilTime
  }
}
    `;
export type RenewMonthlyPassMutationFn = Apollo.MutationFunction<RenewMonthlyPassMutation, RenewMonthlyPassMutationVariables>;

/**
 * __useRenewMonthlyPassMutation__
 *
 * To run a mutation, you first call `useRenewMonthlyPassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewMonthlyPassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewMonthlyPassMutation, { data, loading, error }] = useRenewMonthlyPassMutation({
 *   variables: {
 *      monthlyPassPermitId: // value for 'monthlyPassPermitId'
 *   },
 * });
 */
export function useRenewMonthlyPassMutation(baseOptions?: Apollo.MutationHookOptions<RenewMonthlyPassMutation, RenewMonthlyPassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewMonthlyPassMutation, RenewMonthlyPassMutationVariables>(RenewMonthlyPassDocument, options);
      }
export type RenewMonthlyPassMutationHookResult = ReturnType<typeof useRenewMonthlyPassMutation>;
export type RenewMonthlyPassMutationResult = Apollo.MutationResult<RenewMonthlyPassMutation>;
export type RenewMonthlyPassMutationOptions = Apollo.BaseMutationOptions<RenewMonthlyPassMutation, RenewMonthlyPassMutationVariables>;
export const RenewWeeklyPassDocument = gql`
    mutation RenewWeeklyPass($weeklyPassPermitId: String!) {
  renewWeeklyPass(renewArgs: {weeklyPassPermitId: $weeklyPassPermitId}) {
    id
    untilTime
  }
}
    `;
export type RenewWeeklyPassMutationFn = Apollo.MutationFunction<RenewWeeklyPassMutation, RenewWeeklyPassMutationVariables>;

/**
 * __useRenewWeeklyPassMutation__
 *
 * To run a mutation, you first call `useRenewWeeklyPassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewWeeklyPassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewWeeklyPassMutation, { data, loading, error }] = useRenewWeeklyPassMutation({
 *   variables: {
 *      weeklyPassPermitId: // value for 'weeklyPassPermitId'
 *   },
 * });
 */
export function useRenewWeeklyPassMutation(baseOptions?: Apollo.MutationHookOptions<RenewWeeklyPassMutation, RenewWeeklyPassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewWeeklyPassMutation, RenewWeeklyPassMutationVariables>(RenewWeeklyPassDocument, options);
      }
export type RenewWeeklyPassMutationHookResult = ReturnType<typeof useRenewWeeklyPassMutation>;
export type RenewWeeklyPassMutationResult = Apollo.MutationResult<RenewWeeklyPassMutation>;
export type RenewWeeklyPassMutationOptions = Apollo.BaseMutationOptions<RenewWeeklyPassMutation, RenewWeeklyPassMutationVariables>;
export const UpdateVrmDocument = gql`
    mutation UpdateVrm($monthlyPassPermitId: String!, $newVrm: String!) {
  updateVrm(
    updateVrmArgs: {monthlyPassPermitId: $monthlyPassPermitId, newVrm: $newVrm}
  ) {
    id
    vrm
    untilTime
  }
}
    `;
export type UpdateVrmMutationFn = Apollo.MutationFunction<UpdateVrmMutation, UpdateVrmMutationVariables>;

/**
 * __useUpdateVrmMutation__
 *
 * To run a mutation, you first call `useUpdateVrmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVrmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVrmMutation, { data, loading, error }] = useUpdateVrmMutation({
 *   variables: {
 *      monthlyPassPermitId: // value for 'monthlyPassPermitId'
 *      newVrm: // value for 'newVrm'
 *   },
 * });
 */
export function useUpdateVrmMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVrmMutation, UpdateVrmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVrmMutation, UpdateVrmMutationVariables>(UpdateVrmDocument, options);
      }
export type UpdateVrmMutationHookResult = ReturnType<typeof useUpdateVrmMutation>;
export type UpdateVrmMutationResult = Apollo.MutationResult<UpdateVrmMutation>;
export type UpdateVrmMutationOptions = Apollo.BaseMutationOptions<UpdateVrmMutation, UpdateVrmMutationVariables>;
export const UpdateWeeklyVrmDocument = gql`
    mutation UpdateWeeklyVrm($weeklyPassPermitId: String!, $newVrm: String!) {
  updateWeeklyVrm(
    updateVrmArgs: {weeklyPassPermitId: $weeklyPassPermitId, newVrm: $newVrm}
  ) {
    id
    vrm
    untilTime
  }
}
    `;
export type UpdateWeeklyVrmMutationFn = Apollo.MutationFunction<UpdateWeeklyVrmMutation, UpdateWeeklyVrmMutationVariables>;

/**
 * __useUpdateWeeklyVrmMutation__
 *
 * To run a mutation, you first call `useUpdateWeeklyVrmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWeeklyVrmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWeeklyVrmMutation, { data, loading, error }] = useUpdateWeeklyVrmMutation({
 *   variables: {
 *      weeklyPassPermitId: // value for 'weeklyPassPermitId'
 *      newVrm: // value for 'newVrm'
 *   },
 * });
 */
export function useUpdateWeeklyVrmMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWeeklyVrmMutation, UpdateWeeklyVrmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWeeklyVrmMutation, UpdateWeeklyVrmMutationVariables>(UpdateWeeklyVrmDocument, options);
      }
export type UpdateWeeklyVrmMutationHookResult = ReturnType<typeof useUpdateWeeklyVrmMutation>;
export type UpdateWeeklyVrmMutationResult = Apollo.MutationResult<UpdateWeeklyVrmMutation>;
export type UpdateWeeklyVrmMutationOptions = Apollo.BaseMutationOptions<UpdateWeeklyVrmMutation, UpdateWeeklyVrmMutationVariables>;
export const ValidateMfaDocument = gql`
    mutation ValidateMfa($token: String!, $phone: String!, $siteId: Int!) {
  validateMfa(mfaTokenArgs: {token: $token, phone: $phone, siteId: $siteId}) {
    tokens {
      id
      cardToken
      cardNumber
      cardType
      cardExpiry
      cardHolder
    }
    successful
    error
    plates {
      id
      vrm
    }
  }
}
    `;
export type ValidateMfaMutationFn = Apollo.MutationFunction<ValidateMfaMutation, ValidateMfaMutationVariables>;

/**
 * __useValidateMfaMutation__
 *
 * To run a mutation, you first call `useValidateMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateMfaMutation, { data, loading, error }] = useValidateMfaMutation({
 *   variables: {
 *      token: // value for 'token'
 *      phone: // value for 'phone'
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useValidateMfaMutation(baseOptions?: Apollo.MutationHookOptions<ValidateMfaMutation, ValidateMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateMfaMutation, ValidateMfaMutationVariables>(ValidateMfaDocument, options);
      }
export type ValidateMfaMutationHookResult = ReturnType<typeof useValidateMfaMutation>;
export type ValidateMfaMutationResult = Apollo.MutationResult<ValidateMfaMutation>;
export type ValidateMfaMutationOptions = Apollo.BaseMutationOptions<ValidateMfaMutation, ValidateMfaMutationVariables>;
export const ValidateMonthlyPassMfaDocument = gql`
    mutation ValidateMonthlyPassMfa($phone: String!, $token: String!) {
  validateMonthlyPassMfa(mfaTokenArgs: {phone: $phone, token: $token}) {
    monthlyPasses {
      id
      vrm
      untilTime
      parkingTicketId
      site {
        id
        name
      }
    }
    weeklyPasses {
      id
      vrm
      untilTime
      parkingTicketId
      site {
        id
        name
      }
    }
  }
}
    `;
export type ValidateMonthlyPassMfaMutationFn = Apollo.MutationFunction<ValidateMonthlyPassMfaMutation, ValidateMonthlyPassMfaMutationVariables>;

/**
 * __useValidateMonthlyPassMfaMutation__
 *
 * To run a mutation, you first call `useValidateMonthlyPassMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateMonthlyPassMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateMonthlyPassMfaMutation, { data, loading, error }] = useValidateMonthlyPassMfaMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidateMonthlyPassMfaMutation(baseOptions?: Apollo.MutationHookOptions<ValidateMonthlyPassMfaMutation, ValidateMonthlyPassMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateMonthlyPassMfaMutation, ValidateMonthlyPassMfaMutationVariables>(ValidateMonthlyPassMfaDocument, options);
      }
export type ValidateMonthlyPassMfaMutationHookResult = ReturnType<typeof useValidateMonthlyPassMfaMutation>;
export type ValidateMonthlyPassMfaMutationResult = Apollo.MutationResult<ValidateMonthlyPassMfaMutation>;
export type ValidateMonthlyPassMfaMutationOptions = Apollo.BaseMutationOptions<ValidateMonthlyPassMfaMutation, ValidateMonthlyPassMfaMutationVariables>;
export const ValidateMonthlyUserPhoneDocument = gql`
    mutation ValidateMonthlyUserPhone($phone: String!) {
  validateMonthlyUserPhone(hasTokensArgs: {phone: $phone}) {
    error
    hasPasses
  }
}
    `;
export type ValidateMonthlyUserPhoneMutationFn = Apollo.MutationFunction<ValidateMonthlyUserPhoneMutation, ValidateMonthlyUserPhoneMutationVariables>;

/**
 * __useValidateMonthlyUserPhoneMutation__
 *
 * To run a mutation, you first call `useValidateMonthlyUserPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateMonthlyUserPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateMonthlyUserPhoneMutation, { data, loading, error }] = useValidateMonthlyUserPhoneMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useValidateMonthlyUserPhoneMutation(baseOptions?: Apollo.MutationHookOptions<ValidateMonthlyUserPhoneMutation, ValidateMonthlyUserPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateMonthlyUserPhoneMutation, ValidateMonthlyUserPhoneMutationVariables>(ValidateMonthlyUserPhoneDocument, options);
      }
export type ValidateMonthlyUserPhoneMutationHookResult = ReturnType<typeof useValidateMonthlyUserPhoneMutation>;
export type ValidateMonthlyUserPhoneMutationResult = Apollo.MutationResult<ValidateMonthlyUserPhoneMutation>;
export type ValidateMonthlyUserPhoneMutationOptions = Apollo.BaseMutationOptions<ValidateMonthlyUserPhoneMutation, ValidateMonthlyUserPhoneMutationVariables>;
export const ValidateRenewalDocument = gql`
    query ValidateRenewal($sessionCode: String!) {
  validateRenewal(sessionCode: $sessionCode) {
    renewalInfo {
      vrm
      siteId
      siteName
      duration
      email
      phone
      feeType
      tokens {
        id
        cardToken
        cardNumber
        cardType
        cardExpiry
        cardHolder
      }
    }
    successful
    error
  }
}
    `;

/**
 * __useValidateRenewalQuery__
 *
 * To run a query within a React component, call `useValidateRenewalQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateRenewalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateRenewalQuery({
 *   variables: {
 *      sessionCode: // value for 'sessionCode'
 *   },
 * });
 */
export function useValidateRenewalQuery(baseOptions: Apollo.QueryHookOptions<ValidateRenewalQuery, ValidateRenewalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateRenewalQuery, ValidateRenewalQueryVariables>(ValidateRenewalDocument, options);
      }
export function useValidateRenewalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateRenewalQuery, ValidateRenewalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateRenewalQuery, ValidateRenewalQueryVariables>(ValidateRenewalDocument, options);
        }
export type ValidateRenewalQueryHookResult = ReturnType<typeof useValidateRenewalQuery>;
export type ValidateRenewalLazyQueryHookResult = ReturnType<typeof useValidateRenewalLazyQuery>;
export type ValidateRenewalQueryResult = Apollo.QueryResult<ValidateRenewalQuery, ValidateRenewalQueryVariables>;
export function refetchValidateRenewalQuery(variables: ValidateRenewalQueryVariables) {
      return { query: ValidateRenewalDocument, variables: variables }
    }